






























import { Vue, Component, Prop } from 'vue-property-decorator';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import segmentIo from '@/utils/segment.io';
import eventBus from '@/utils/eventBus';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import CloseModalIcon from '@/components/icons/CloseModal.vue';
import InfoIcon from '@/components/icons/InfoSolid.vue';

@Component({
  components: {
    FilledButton,
    Typography,
    CloseModalIcon,
    InfoIcon
  }
})
export default class StopFlowModal extends Vue {
  @Prop() onConfirm!: () => void;

  created() {
    segmentIo.modal('AI Sign Up | Stop The Magic');
  }

  onClose() {
    eventBus.$emit('closeModal');
  }
}
